import { render, staticRenderFns } from "./SideBarButton.vue?vue&type=template&id=63b78901&"
import script from "./SideBarButton.vue?vue&type=script&lang=js&"
export * from "./SideBarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports